export default "__VITE_ASSET__V1353OMp__"